import { render } from "./more.vue?vue&type=template&id=061989d2"
const script = {}
script.render = render

export default script